import Connexion from "../Pages/Auth/Connexion";
import MesCours from "../Pages/MesCours/MesCours";
import Inscription from "../Pages/Auth/Inscription";
import PasswordOublier from "../Pages/Auth/PasswordOublier";
import ResetPassword from "../Pages/Auth/ResetPassword";
import PolitiqueConfidentialite from '../Pages/Commun/PolitiqueConfidentialite/PolitiqueConfidentialite'

import LayoutAdmin from "../Layout/LayoutAdmin/LayoutNavSide";
import User from "../Pages/Admin/User/User";
import Dashbord from "../Pages/Admin/Dashbord/Dashbord";
import Cours from "../Pages/Admin/Cours/Cours";
import CategoryCourses from "../Pages/Admin/Cours/CategoryCourses/CategoryCourses";
import AjoutCours from "../Pages/Commun/AjoutCours/AjoutCours";
import EtudiantDasbord from "../Pages/Students/EtudiantDasbord/EtudiantDasbord";
import ListEtudiant from "../Pages/Prof/list-etudiants/ListEtudiant";
import LayoutProf from "../Layout/LayoutProf/LayoutNavSide";
import LayoutStudents from "../Layout/LayoutStudents/LayoutNavSide";
import AllCourses from "../Pages/Admin/Cours/AllCourses/AllCourses";
import TableauUsers from "../Pages/Commun/TableauUsers/TableauUsers";
import Profile from "../Pages/Admin/Profile/Profile";
import Profil from "../Pages/Admin/Profil/Profil";
import Parametre from "../Pages/Admin/Parametre/Parametre";
import {
  INSCRIPTION_NAVIGATION,
  CONNEXION_NAVIGATION,
  PASSWORD_OUBLIER_NAVIGATION,
  PASSWORD_RESET_NAVIGATION,
  DASHBOARD_ADMIN_NAVIGATION,
  COURS_ADMIN_NAVIGATION,
  AJOUT_COURS__ADMIN,
  LIST_ETUDIANT,
  USERS_ADMIN_NAVIGATION,
  PROFIL_NAVIGATION,
  MODIFIER_PROFIL_NAVIGATION,
  INFO_COURS,
  PARAMETRE_NAVIGATION,
  TABLEAU_USERS,
  PROFIL_ADMIN_NAVIGATION,
  MODIFIER_PROFIL_ADMIN_NAVIGATION,
  PARAMETRE_ADMIN_NAVIGATION,
  LISTE_PROF,
  DASHBOARD_PROF_NAVIGATION,
  COURS_PROF_NAVIGATION,
  ETUDIANTS_PROF_NAVIGATION,
  PROFIL_PROF_NAVIGATION,
  MODIFIER_PROFIL_PROF_NAVIGATION,
  CATEGORIE_COURS_NAVIGATION,
  ALL_COURS_NAVIGATION,
  DASHBOARD_ETUDIANT_NAVIGATION,
  COURS_ETUDIANT_NAVIGATION,
  MODIFIER_PROFIL_ETUDIANT_NAVIGATION,
  PARAMETRE_ETUDIANT_NAVIGATION,
  USERS_ADMIN_NAVIGATION_ETUDIANTS,
  AJOUT_COURS_NAVIGATION,
  MODIFIER_COURS_NAVIGATION,
  LISTE_ARCHIVE,
  LISTE_ARCHIVE_STUDENT,
  MODIFIER_COURS_ADMIN_NAVIGATION,
  INFOS_COURS_ADMIN_NAVIGATION,
  POLITIQUE_DE_CONFIDENTIALITE,
} from "./NAVIGATION_PATH";
import ProfPage from "../Pages/Admin/User/ProfPage/ProfPage";
import StudentPage from "../Pages/Admin/User/StudentPage/StudentPage";
import InfoCours from "../Pages/Commun/infoCours/InfoCours";
import ModifCours from "../Pages/Commun/ModifCours/ModifCours";
import Archive from "../Pages/Admin/Archive/Archive";
import { Navigate } from "react-router-dom";

const SecureRoute = ({ children, typeUser }) => {
  const user = JSON.parse(sessionStorage.getItem("user"));
  const isAuth = user?.id;
  const isAccess = isAuth && typeUser?.includes(user?.user_type);
  return isAccess && isAccess !== undefined ? (
    children
  ) : (
    <Navigate to="/" replace />
  );
};

export const authRoutes = [
  {
    path: CONNEXION_NAVIGATION,
    element: <Connexion />,
  },
  {
    path: INSCRIPTION_NAVIGATION,
    element: <Inscription />,
  },
  {
    path: PASSWORD_OUBLIER_NAVIGATION,
    element: <PasswordOublier />,
  },
  {
    path: PASSWORD_RESET_NAVIGATION,
    element: <ResetPassword />,
  },
  {
    path: POLITIQUE_DE_CONFIDENTIALITE,
    element: <PolitiqueConfidentialite />,
  },
];
export const adminRoutes = [
  {
    path: DASHBOARD_ADMIN_NAVIGATION,
    element: (
      <SecureRoute typeUser="admin">
        <LayoutAdmin />
      </SecureRoute>
    ),
    children: [
      {
        path: "?",
        element: <Dashbord />,
      },

      {
        path: COURS_ADMIN_NAVIGATION,
        element: <Cours />,
      },
      {
        path: `${INFOS_COURS_ADMIN_NAVIGATION}/:id`,
        element: <InfoCours />,
      },
      {
        path: AJOUT_COURS__ADMIN,
        element: <AjoutCours />,
      },
      {
        path: TABLEAU_USERS,
        element: <TableauUsers />,
      },

      {
        path: `${MODIFIER_COURS_ADMIN_NAVIGATION}:id`,
        element: <ModifCours />
      },
      {
        path: `${LISTE_ARCHIVE}:user_type`,
        element: <Archive />,
      },
      {
        path: `${LISTE_ARCHIVE_STUDENT}:user_type`,
        element: <Archive />,
      },

      {
        path: USERS_ADMIN_NAVIGATION,
        element: <User />,
        children: [
          {
            path: "?",
            element: <ProfPage />,
          },
          {
            path: USERS_ADMIN_NAVIGATION_ETUDIANTS,
            element: <StudentPage />,
          },
        ],
      },

      {
        path: PROFIL_NAVIGATION,
        element: <Profil />,
      },
      {
        path: MODIFIER_PROFIL_NAVIGATION,
        element: <Profile />,
      },
      {
        path: PARAMETRE_NAVIGATION,
        element: <Parametre />,
      },
    ],
  },
];
export const profRoutes = [
  {
    path: DASHBOARD_PROF_NAVIGATION,
    element: (
      <SecureRoute typeUser="prof">
        <LayoutProf />
      </SecureRoute>
    ),
    children: [
      {
        path: "?",
        element: <MesCours />,
      },
      {
        path: `${INFO_COURS}/:id`,
        element: <InfoCours />,
      },
      {
        path: `${MODIFIER_COURS_NAVIGATION}:id`,
        element: <ModifCours />
      },
      {
        path: ETUDIANTS_PROF_NAVIGATION,
        element: <ListEtudiant />,
      },
      {
        path: LIST_ETUDIANT,
        element: <ListEtudiant />,
      },
      {
        path: AJOUT_COURS_NAVIGATION,
        element: <AjoutCours />,
      },
      {
        path: PROFIL_NAVIGATION,
        element: <Profil />,
      },
      {
        path: MODIFIER_PROFIL_PROF_NAVIGATION,
        element: <Profile />,
      },
      {
        path: PARAMETRE_NAVIGATION,
        element: <Parametre />,
      },
    ],
  },
];
export const etudiantRoutes = [
  {
    path: DASHBOARD_ETUDIANT_NAVIGATION,
    element: (
      <SecureRoute typeUser="etudiant">
        <LayoutStudents />
      </SecureRoute>
    ),
    children: [
      {
        path: "?",
        element: <EtudiantDasbord />,
      },
      {
        path: `${INFO_COURS}/:id`,
        element: <InfoCours />,
      },
      {
        path: PROFIL_NAVIGATION,
        element: <Profil />,
      },
      {
        path: MODIFIER_PROFIL_NAVIGATION,
        element: <Profile />,
      },
      {
        path: PARAMETRE_NAVIGATION,
        element: <Parametre />,
      },
     
    ],
  },
];
